export const TUPLE_SELECTOR_TEXT = `Forge expression yielding tuples (arity ≥ 2); constraint applies from first to last element.`;
export const UNARY_SELECTOR_TEXT = `Forge expression yielding singletons.`;

export const CYCLIC_DESCRIPTION = "Arrange elements along the perimeter of a circle."
export const ORIENTATION_DESCRIPTION = "Specify the relative positioning of elements."
export const ALIGN_DESCRIPTION = "Ensure elements are aligned horizontally or vertically."
export const GROUPING_SELECTOR_DESCRIPTION = "Group elements based on a selector."
export const GROUPING_FIELD_DESCRIPTION = "Group elements based on a field."